import React, { useState, useContext, useEffect } from 'react';
import propTypes from 'prop-types';

import { QuoteContext } from '../QuoteProvider';
import { QuantityContext } from '../../QuantitySelector/QuantityProvider';
import { formatCurrency } from '../../../utilities/financing';
import { Checkbox } from '../../leaf-components/Checkbox';
import { Tooltip } from '../../Tooltip';
import addonConstants from './addonConstants';

const {
  tpmsServiceKitId,
  tpmsServiceUnitPrice,
} = addonConstants;

const calculatePrice = (quantity) => tpmsServiceUnitPrice * quantity;

const TPMSServiceKit = ({ isSplitFitment }) => {
  const [checked, setChecked] = useState(false);
  const [ready, setReady] = useState(false);
  const { setAddons } = useContext(QuoteContext);
  const { quantities } = useContext(QuantityContext);

  useEffect(() => {
    const { qtyFront, qtyRear } = quantities;

    const tpmsServiceKit = [
      {
        id: tpmsServiceKitId,
        checked,
        description: '',
        name: `${isSplitFitment ? 'Front ' : ''}TPMS Service Kit`,
        position: 0,
        qty: qtyFront,
        type: 'ADDON',
        free: false,
        disabled: false,
        subs: [],
        unitPrice: tpmsServiceUnitPrice,
      },
    ];

    if (isSplitFitment) {
      tpmsServiceKit.push({
        id: tpmsServiceKitId,
        checked,
        description: '',
        name: 'Rear TPMS Service Kit',
        position: 1,
        qty: qtyRear,
        type: 'ADDON',
        free: false,
        disabled: false,
        subs: [],
        unitPrice: tpmsServiceUnitPrice,
      });
    }

    setAddons((addons) => ({
      ...addons,
      TPMSServiceKit: tpmsServiceKit,
    }));
  }, [checked, isSplitFitment, quantities, setAddons]);

  useEffect(() => {
    // force re-render of checkbox on mount to prevent webkit
    // from caching state through history navigation
    setTimeout(() => { setReady(true); }, 80);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTotalPrice = () => {
    const { qtyFront, qtyRear } = quantities;

    return isSplitFitment
      ? calculatePrice(qtyFront + qtyRear)
      : calculatePrice(qtyFront);
  };

  return (
    <div className="cmp-quote-option__card">
      <div className="cmp-quote-option">
        <div className="cmp-quote-option__item">
          { ready && (
            <Checkbox
              id="tpms-service-kit"
              label="TPMS Service Kit"
              size="lg"
              checked={checked}
              onChange={() => setChecked(!checked)}
            />
          )}
          <Tooltip name="tpms service kit" />
        </div>
        <div className="cmp-quote-option__quantity">
          Quantity:
          {' '}
          {
            isSplitFitment
              ? (quantities.qtyFront + quantities.qtyRear)
              : quantities.qtyFront
          }
        </div>
        <div className="cmp-quote-option__unit-price">
          Unit Price:
          {' '}
          {formatCurrency(tpmsServiceUnitPrice)}
        </div>
        <div
          className={
            checked
              ? 'cmp-quote-option__total cmp-quote-option__total--selected'
              : 'cmp-quote-option__total'
          }
        >
          {formatCurrency(getTotalPrice())}
        </div>
      </div>
    </div>
  );
};

TPMSServiceKit.propTypes = {
  isSplitFitment: propTypes.bool,
};

export { TPMSServiceKit };
